/**
 * @group Client
 * @summary Client-safe exports for browser/React components.
 *
 * <blockquote>
 * Use this entry point from client components (e.g. 'use client') to avoid
 * bundling server-only code (middleware with node:crypto).
 * </blockquote>
 *
 * @example
 * ```typescript
 * import { useAuthorize, useClientSession } from '@shared/auth/client';
 * import type { UserSession } from '@shared/auth/client';
 * ```
 */

export { useAuthorize, useClientSession } from '../src/hooks';
export type { UserSession } from '../src/types/core/UserSession';
